// 快讯日历接口
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList

export default axios => ({
  // 初始化 /wikifxweb-v1/live/calendar/index/init-v1
  init: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/live/calendar/index/init-v1`, params),
  // 根据条件过滤需求 /wikifxweb-v1/live/calendar/index/filter-v1
  filter: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/live/calendar/index/filter-v1`, params),
  // Echarts的detailsInit
  detailsInit: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/live/calendar/detail/init-v1`, params),
  // 详情页初始化 /wikifxweb-v1/live/calendar/index/more-v1
  more: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/live/calendar/index/more-v1`, params)
})
